// frontend/src/components/PrivateRoute.jsx
// 路由保護元件

import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useAuth } from '../hooks/useAuth';

/**
 * 私有路由元件
 * @param {Object} props
 * @param {import('react').ComponentType} props.children - 子元件
 * @param {String[]} props.roles - 允許的角色陣列（可選）
 * @param {String} props.requiredRole - 需要的最低角色（可選）
 */
const PrivateRoute = ({ children, roles, requiredRole }) => {
  const location = useLocation();
  const { isAuthenticated, user, loading, hasRole } = useAuth();

  // 載入中
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // 未登入，導向登入頁
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 檢查角色權限
  if (roles && roles.length > 0) {
    if (!roles.includes(user?.role)) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
          <Alert severity="error">權限不足：您需要 {roles.join(' 或 ')} 角色才能訪問此頁面</Alert>
        </Box>
      );
    }
  }

  // 檢查最低角色要求
  if (requiredRole) {
    if (!hasRole(requiredRole)) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
          <Alert severity="error">權限不足：您需要 {requiredRole} 以上的角色才能訪問此頁面</Alert>
        </Box>
      );
    }
  }

  // 權限通過，顯示子元件
  return children;
};

export default PrivateRoute;
